module.exports = __webpack_public_path__ + "static/media/icn-menu.59ffbc76.svg";